export enum NotificationType {
    LastSurvey = 1,
    LastSales = 2
}
